// extracted by mini-css-extract-plugin
module.exports = {"channelCardsWrapper":"form_channelCardsWrapper__dVSVk","submitButtonWrapper":"form_submitButtonWrapper__viaVu"};